<template>
  <div
    ref='root'
    v-show='visible'
    class='popup terms'
  >
    <div class='content'>
          <div class="lab-modal-scroll">        
          <iframe
            ref="termsFrame"
            src="/static/documents/EMARF_for_Owners_β版_利用規約draft_250519.html"
            style="width:100%;height:50vh;border:none;"
            @load="removeIframePadding"
            title="利用規約"            
          ></iframe>

      </div>
      <p>To upload data or download sbp files, please make sure you agree with <a href='/static/documents/EMARF_TOS_V200.pdf' target='_blank'>our terms of service</a>. <br> ３Dデータのアップロード及びShopbotファイルのダウンロードには<a href='/static/documents/EMARF_TOS_V200.pdf' target='_blank'>利用規約</a>に同意して頂く必要があります。</p>
      <div>
        <input id='terms' type='checkbox' v-model='checked' />
        <label for='terms'>I agree with terms of service / 同意する</label>
      </div>
    </div>
    <div class='close'>
      <a @click='onClose'>
        <img src='@/assets/images/ui/close.png' />
      </a>
    </div>
  </div>
</template>

<script>

import PopupBase from './PopupBase.vue';

const termsKeyChecked = 'emarf_terms_checked';

export default {
  name: 'TermsPopup',
  extends: PopupBase,
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    checked: {
      get () {
        //return false;
        
        return this.isChecked();
      },
      set (v) {
        console.log('set v is: ', v);
        //localStorage.setItem(termsKeyChecked, v);
        this.onChecked(v);
      }
    }
  },
  mounted () {
  },
  methods: {
    isChecked () {
      //let ret = localStorage.getItem(termsKeyChecked);
      // if (ret === null) {
      //   return false;
      // }
      return false;
    },
    onChecked (v) {
      if (v) {
        this.$emit('checked');
      } 
    },
    onClose () {
      console.log('onClose');
      this.$emit('close');
    }
  }
};

</script>



// WEBPACK FOOTER //
// src/components/TermsPopup.vue